/**
 * Hand a blob to the browser as a file download.
 *
 * The anchor must be in the document before it is clicked. A detached anchor
 * works in some browsers and silently does nothing in others, which is how a CSV
 * export ends up looking like it worked while downloading nothing.
 *
 * The object URL is revoked on a delay rather than immediately: revoking it in
 * the same tick cancels the download in Chrome.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  anchor.style.display = "none";

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}